
export interface AssessmentGroupInfo {
    testCode: string,
    loginId: number,
    contentAreaId: number
}

export interface GroupMaster {
    id: number
    name: string
    groupType: GroupType
    defaultGroup: boolean | undefined
    canView: boolean | undefined
    testingGroupInfo: AssessmentGroupInfo[]
    groupId: number
}


export interface ManageGroupsGroupMasterCronDTO {
    groupId: number,
    groupType: GroupType | null,
    name: string,
    parentGroupId: number | null,
    mostRecentTestData: Date | null,
    addedMostRecentTestData: boolean | null,
    ssoGroupId: string | null,
    sisOtherData: {[key: string]: string | null} | null,
    ssoTeachers: string[] | null,
    ssoStudents: string[] | null,
    sfAccountId: string | null,
    sfParentAccountId: string | null,
    sfCreated: Date | null,
    ledgerShortCode: string | null,
    addHocTestingGroup: boolean,
    testSettings: TestSettings | null,
    updated: Date | null,
    created: Date | null,
}

export interface  TestSettings {
    productLabel: string | null,
    allowHandwritten: boolean,
    estTestingDate: string | null,
    languageId: number | null,
    testId: number | null,
    seatsAllowed: number | null,
    seatsResearved: number | null,
    seatsUsed: number | null,
    ssoentityid: number | null,
    ssoAppendTeacherNamesToClassNames: boolean,
    ssoAppendPeriodNamesToClassNames: boolean,
    restart: boolean,
    studentIDField: string | null,
    teacherIDField: string | null,
    staffIDField: string | null,
    keepStartFence: boolean,
}

export function sortGroupMasterByName(groups: GroupMaster[]): GroupMaster[] {
    if (groups.length === 0) {
        return groups
    }
    return groups.sort((a: GroupMaster, b: GroupMaster) => {
        if (a.name < b.name) {
            return -1
        } else if (a.name > b.name) {
            return 1
        } else {
            return 0
        }
    })
}

export enum GroupType {
    STATE = "ST",
    DISTRICT = "D",
    SCHOOL = "SC",
    CLASS = "CL",
    CUSTOMER = "C",
    LOCATION = "L",
}
